// src/AdminProtectedRoute.js

import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from './AuthContext';

const AdminProtectedRoute = () => {
  const { user, isLoading } = useAuth();

  // 1. Wait for the user data to be loaded
  if (isLoading) {
    return <div>Loading session...</div>;
  }

  // 2. Check if user exists and if their role is 'admin'
  const isAdminOrManager = user && (user.role === 'admin' || user.role === 'manager');

  // 3. If they are an admin, show the page. Otherwise, redirect them.
  return isAdminOrManager ? <Outlet /> : <Navigate to="/home" replace />;
};

export default AdminProtectedRoute;